import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import {Link} from "react-router-dom";
import {connect}  from  "react-redux";
import axios from "axios";

class TableauProject extends Component{
    constructor(props) {
        super(props);
        this.state = {
            reportPermissionsArray:[],
            tableau_projects:[]
        }
    }
     componentWillMount() {
        this.props.currentMenu("unipaynext");
     }
    componentDidMount() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.get_tableau_project(decoded.user_department);
    }

    get_tableau_project(user_department){
        axios.post(config.get('API_URL')+'/tableau/get-tableau-project/',
         {
            user_department: user_department
         },
         {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },

        }).then(response => {
            this.setState({
                tableau_projects: response.data
            })
            if(response.data.length<1){
                alert("You Don't have permission to view this reports")
            }
        }).catch( err => {
            console.log(err);
        });
    }
    render() {

        let projectData = this.state.tableau_projects.map((val,index) => {
            let linkUrl = "/admin/tableau-workbook/"+val.project_id;
            return (
                <div className="col-lg-3 col-xs-6">
                    <div className="card report-dash">
                        <div className="content text-center">
{/*                          <Link className="" to={{ pathname: '/admin/tableau-workbook/', query: { kpi_id: val.kpi_id } }} */}
{/*                             > */}
                            <Link className="" to={linkUrl} >
                                <div className="report-thumbs-ico">
                                    <div className="icon-big text-center folder-icon">
                                        <i className="fa fa-folder-o"></i>
                                    </div>
                                    <h5>{val.project_name}</h5>
                                   {/*<p className="text-muted">2020-03-28 00:00:00</p>*/}

                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            )
        });
        return(
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div className="">
                                <div className="content">
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <div className="card title-card-bottom-space">
                                                <nav aria-label="breadcrumb">
                                                    <ol className="breadcrumb">
{/*                                                         <li class="breadcrumb-item"> */}
{/*                                                             <a href="#pablo">Breadcrumb 1</a> */}
{/*                                                         </li> */}
{/*                                                         <li class="breadcrumb-item"> */}
{/*                                                             <a href="#pablo">Breadcrumb2</a></li> */}
                                                        <li aria-current="page" class="breadcrumb-item active">Project</li>
                                                    </ol>
                                                </nav>
{/*                                                 <div className="header"> */}
{/*                                                     <h4 className="title">Project</h4> */}
{/*                                                     <p className="category"></p> */}
{/*                                                 </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/*<div className="header">*/}
                                {/*    <h4 className="title">Transaction</h4>*/}
                                {/*    <p className="category"></p>*/}
                                {/*</div>*/}
                                <div className="content">
                                    <div className="row">
                                        {projectData}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}
const mapDispatchToProps = (dispatch) =>{
  return {
  currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
  }
}
export default connect(null,mapDispatchToProps)(TableauProject);